<template>
  <div id="about" class="about-wrap style3 pb-100">
    <div class="container">
      <div class="row gx-5 align-items-center">
        <div class="col-lg-6">
          <div class="about-img-wrap">
            <img
              class="about-img-one"
              src="../../assets/images/about/about-img-4.jpg"
              alt="Image"
            />
            <div class="about-img-two">
              <img
                src="../../assets/images/about/about-img-5.jpg"
                alt="Image"
              />
            </div>
            <div class="about-promo-text">
              <h5><span>30+</span> Years Of Experience</h5>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="about-content">
            <div class="content-title style3">
              <span>Company Introduction</span>
              <h2>
                We Provide Special Care Through Our
                <span>Certified &amp; Experience</span> Doctors
              </h2>
              <p>
                It is a long established fact that a reader will be distracted
                by the readable content of a page when looking at its layout.
                The point of using amet has.
              </p>
            </div>

            <div class="feature-item-wrap">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-professional"></i>
                </div>
                <div class="feature-text">
                  <h5>Specialist Doctors With Experience</h5>
                </div>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="flaticon-stethoscope"></i>
                </div>
                <div class="feature-text">
                  <h5>Open 24/7 To Serve The People</h5>
                </div>
              </div>
            </div>

            <ul class="content-feature-list list-style style4">
              <li>
                <span><i class="ri-check-double-line"></i></span>Stop worrying,
                we will take care of your physical problems
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Challenges with
                dental insurance can take valuable time
              </li>
              <li>
                <span><i class="ri-check-double-line"></i></span>Dental
                insurance issues are the most important that dentists face
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyIntroduction",
};
</script>